module.exports = __webpack_public_path__ + "static/GTSuperDisplay-Regular-01afff72a7facfbefb79d35d98338c1f.woff";